var _a;
export var StopwatchStates;
(function (StopwatchStates) {
    StopwatchStates["STOPPED"] = "stopwatch-stopped";
    StopwatchStates["RUNNING"] = "stopwatch-running";
    StopwatchStates["LOADING"] = "stopwatch-loading";
})(StopwatchStates || (StopwatchStates = {}));
export var StopwatchLabels = (_a = {},
    _a[StopwatchStates.STOPPED] = 'start stopwatch',
    _a[StopwatchStates.RUNNING] = 'stop stopwatch',
    _a[StopwatchStates.LOADING] = 'stopwatch loading',
    _a);
export var REFRESH_INTERVAL = 30000;
//# sourceMappingURL=StopwatchProps.js.map